import { getCurrentDate, getCurrentDateOfBelow } from "../../services/DateServices"

export const customerList = {
    Asset: "",
    CustomerContract: "",
    contractNumber: "",
    Flag: "",
    GroupFlag: "",
    EquipmentList: []
}
export const equipmentList = {
    Equipment: "",
    Make: "",
    Model: "",
    //LubeMake : "",
    //LubeModel: "",
    LoBrand: "",
    LoGrade: "",
    LastSampleDate: "",
    SamplingFrequency: "",
    EquipmentIdNo: "",
    NextSampleDate: "",
    Flag: "",
    ScheduleId: "",
}
export const Shedulerfilter = {
    contractStartDate: getCurrentDateOfBelow(30),
    contractEndDate: getCurrentDate()
}